import React, { useEffect, useState } from "react";
import { Form, Input, Select } from "antd";
import toast from "react-hot-toast";
import Segmented from "../../components/segmented/Segmented.jsx";
import MT5AccountsPending from "./MT5AccountsPending.jsx";
import MT5AccountAccepted from "./MT5AccountAccepted.jsx";
import MT5AccountReject from "./MT5AccountReject.jsx";
import { GetAcountDetailsByLoginId, GetAllAccountApi, SyncMT5Account } from "../../api/request/account.js";
import ExportHandler from "../../components/global/export/ExportHandler.jsx";
import { GetAllAccountTypeApi } from "../../api/request/ibapproved.js";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import { UpdateAccountTypeApi } from "../../api/request/accountType.js";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx";
import columns from "../../columns/MT5Account/UpdateAcTypeError.js";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import UserAvatar from "../../components/global/avtar/UserAvatar.jsx";
import { GetAllTraderApi } from "../../api/request/client.js";
import useModulePermissions from "../../hooks/useModulePermissions.jsx";
const { Search } = Input;


export default function Accounts() {
  const accountPermissions = useModulePermissions('account');
  const canSync = !!accountPermissions.sync;
  const canExport = !!accountPermissions.export;
  const canUpdate = !!accountPermissions.update;
  const [form] = Form.useForm();
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [value, setValue] = useState("Pending");
  const [accountTypes, setAccountTypes] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedAccountType, setSelectedAccountType] = useState(null);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [updateError, setUpdateError] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [mt5AcDetails, setMt5AcDetails] = useState({});
  const [selectedAccountTypeSync, setSelectedAccountTypeSync] = useState(null);
  const [fromAccount, setFromAccount] = useState(null);
  const [approvedAccountsFrom, setApprovedAccountsFrom] = useState([]);
  const [isAcSyncModalOpen, setIsAcSyncModalOpen] = useState(false);
  const [fromLoading, setFromLoading] = useState(false);
  const [accountsLoadingFrom, setAccountsLoadingFrom] = useState(false);
  const [finalLoading, setFinalLoading] = useState(null);


  const getAllAccountTypes = async () => {
    try {
      const params = { AccountType: true };
      const { data } = await GetAllAccountTypeApi(
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        const options = data?.data
          ?.filter(item => item?.domain === "upforex.live")
          ?.map(item => ({
            label: `${item?.planName} (${item?.groupName})`,
            value: item?.planId,
          }));
        setAccountTypes(options);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getAllAccountTypes();
  }, []);

  const handleUpdateAccountType = async () => {
    if (!selectedAccountType || !selectedRowKeys?.length) return;

    setIsUpdateLoading(true);
    try {
      const params = {
        loginIds: selectedRowKeys,
        accountTypeId: selectedAccountType,
      };
      const { data } = await UpdateAccountTypeApi(params);
      if (data?.success) {
        toast.success(data?.message);
        setSelectedRowKeys([]);
        setSelectedAccountType(null);
        setIsRefresh(!isRefresh);
        if (data?.data?.length) {
          setUpdateError(
            data?.data?.map((item) => ({
              ...item,
              userDetails: (
                <UserAvatar
                  data={{
                    name: item?.name,
                    email: item?.email,
                    profileImage: item?.profileImage,
                  }}
                />
              ),
            }))
          );
          setIsOpenModal(true);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "An error occurred");
    } finally {
      setIsUpdateLoading(false);
    }
  };

  const handleFinalSubmit = async () => {
    try {
      setFinalLoading(true);
      const params = {
        userId: fromAccount?.userId,
        login: mt5AcDetails?.login,
        accountTypeId: selectedAccountTypeSync,
        isLive: true,
      };

      const { data } = await SyncMT5Account(params);
      setFinalLoading(false);
      if (data?.success) {
        toast.success(data?.message);
        setIsAcSyncModalOpen(false);
        // logoutHandler();
      }
    } catch (error) {
      const message = error?.response?.data?.error?.message || error?.response?.data?.message || error?.message;
      toast.error(message);
    } finally {
      setFinalLoading(false);
    }
  };

  const handleFromAccountSearch = async (loginId) => {
    try {
      setFromLoading(true);
      const { data } = await GetAcountDetailsByLoginId(loginId);
      if (data?.success) {
        // setFromAccount({ ...data?.data, terminalId });
        setMt5AcDetails(data?.data[0]);
      }
    } catch (error) {
      const message = error?.response?.data?.error?.message || error?.response?.data?.message || error?.message;
      toast.error(message);
      // form.resetFields();
    } finally {
      setFromLoading(false);
    }
  };

  const debouncedClientSearch = customDebounce((value, type) => {
    if (value.length >= 3) {
      if (type === "from") {
        fetchApprovedAccountsFrom(value);
      }
    }
  }, 500);

  function customDebounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  const fetchApprovedAccountsFrom = async (query) => {
    try {
      setAccountsLoadingFrom(true);
      const params = {
        PageNumber: 1,
        PageSize: 10,
        UserType: "",
        KYCType: "",
        FTDType: "",
        CountryName: "",
        SearchText: query || "",
      };
      const { data } = await GetAllTraderApi(
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        setApprovedAccountsFrom(data?.data || []);
      } else {
        setApprovedAccountsFrom([]);
      }
    } catch (error) {
      const message = error?.response?.data?.error?.message || error?.response?.data?.message || error?.message;
      toast.error(message);
      setApprovedAccountsFrom([]);
    } finally {
      setAccountsLoadingFrom(false);
    }
  };

  const exportHandler = async () => {
    try {
      let params = {
        ApplyPagination: false,
        SearchText: searchText,
        FilterText:
          value === "Pending"
            ? "Pending"
            : value === "Approved"
              ? "Approved"
              : value === "Declined"
                ? "Rejected"
                : value,
        SortBy: "createdDate",
      };
      const { data } = await GetAllAccountApi(
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        return {
          data: data?.data,
          removableColumns: ["userId", "mT5Id"],
          fileName: "Accounts",
        };
      } else {
        return { data: [], removableColumns: [] };
      }
    } catch (error) {
      return { data: [], removableColumns: [] };
    }
  };

  return (
    <div>
      <div className="flex justify-between flex-wrap gap-5 items-center">
        <div className="flex flex-wrap items-center gap-3">
          <Segmented
            options={["Pending", "Approved", "Declined"]}
            value={value}
            setValue={setValue}
          />
          {canSync ? (
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold px-4 py-1.5 rounded-lg"
              lable={"MT5 Account Sync"}
              onClick={() => {
                form.resetFields(); // 🔥 clears Search + Select
                setMt5AcDetails({});
                setSelectedAccountTypeSync(null);
                setFromAccount(null);
                setApprovedAccountsFrom([]); // optional: clear user list
                setIsAcSyncModalOpen(true);
              }}
            />
          ) : null}
        </div>
        <div className="flex items-center gap-3">
          {canUpdate && value === "Approved" && selectedRowKeys?.length ? (
            <div className="flex items-center gap-3">
              <Select
                className="w-80 ant-select-selector-white"
                placeholder="Select account type"
                options={accountTypes}
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={selectedAccountType}
                onChange={(value) => setSelectedAccountType(value)}
              />

              <LoadableButton
                className="bg-primary text-sm text-white font-semibold px-4 py-2 rounded-lg"
                lable="Update"
                loadingLable="updating..."
                isLoading={isUpdateLoading}
                onClick={handleUpdateAccountType}
                disabled={isUpdateLoading || !selectedAccountType}
              />
            </div>
          ) : null}

          <div>
            <Input
              size="large"
              style={{ width: 220 }}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onPressEnter={() => setSearchText(search)}
              prefix={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                    clip-rule="evenodd"
                  />
                </svg>
              }
              suffix={
                search && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      setSearchText("");
                      setSearch("");
                    }}
                    viewBox="0 0 24 24"
                    fill="#bebebe"
                    className="size-5 cursor-pointer duration-300 hover:fill-[#969595]"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                )
              }
            />
          </div>

          {canExport && <div>
            <ExportHandler exportHandler={exportHandler} />
          </div>}
        </div>
      </div>

      {value === "Pending" ? <MT5AccountsPending dates={searchText} /> : null}

      {value === "Approved" ? (
        <MT5AccountAccepted
          dates={searchText}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          isRefresh={isRefresh}
        />
      ) : null}

      {value === "Declined" ? <MT5AccountReject dates={searchText} /> : null}

      <ModalComponent
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        title="Update Account Type Error"
        width={1200}
      >
        <TableWithSkeleton columns={columns} data={updateError} />
      </ModalComponent>

      <ModalComponent
        isOpen={isAcSyncModalOpen}
        setIsOpen={setIsAcSyncModalOpen}
        title={"MT5 Account Sync"}
        width={600}
      >
        <Form form={form}>
          {/* Search MT5 Account */}
          <div className="grid sm:grid-cols-2 gap-3">
            <div className="input-white ">
              <label className="text-base font-medium">
                {"Search MT5 Account"}
              </label>
              <Form.Item
                name="mt5Login"
                rules={[{ required: true, message: "pleaseEnterLoginId" }]}
              >
                <Search
                  placeholder={"Search by account no."}
                  enterButton={"search"}
                  loading={fromLoading}
                  onSearch={handleFromAccountSearch}
                />
              </Form.Item>
            </div>
          </div>

          {/* MT5 ACCOUNT DETAILS */}
          <div className="border border-light p-4 rounded-lg bg-secondaryBackground my-3">
            <h3 className="font-semibold text-lg mb-3">
              {"MT5 Account Details"}
            </h3>

            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <span className="font-medium">{"First Name"}</span>
                <div>{mt5AcDetails?.firstName || "-"}</div>
              </div>

              <div>
                <span className="font-medium">{"Last Name"}</span>
                <div>{mt5AcDetails?.lastName || "-"}</div>
              </div>

              <div>
                <span className="font-medium">{"Group"}</span>
                <div>{mt5AcDetails?.group || "-"}</div>
              </div>

              <div>
                <span className="font-medium">{"Balance"}</span>
                <div>{mt5AcDetails?.balance ?? "-"}</div>
              </div>
            </div>
          </div>

          {/* Select User */}
          <div className="input-white mt-4">
            <label className="text-base font-medium block">
              {"Select User"}
            </label>

            <Form.Item
              name="selectedUser"
              rules={[{ required: true, message: "Please select user" }]}
            >
              <Select
                className="ant-select-selector-white"
                showSearch
                placeholder={"Search account"}
                loading={accountsLoadingFrom}
                optionFilterProp="labelText"
                filterOption={(input, option) =>
                  String(option?.labelText || "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(value) => {
                  const acc = approvedAccountsFrom.find(
                    (a) => a.userId === value
                  );
                  setFromAccount(acc || null);
                }}
                onSearch={(value) => {
                  debouncedClientSearch(value, "from");
                }}
                options={approvedAccountsFrom.map((a) => ({
                  value: a.userId,
                  label: (
                    <div className="flex gap-3 items-center text-sm">
                      <span className="font-medium">{a?.name || "-"}</span>
                      <span className="text-xs text-gray-500">{a?.email || "-"}</span>
                    </div>
                  ),
                  labelText: `${a?.name || ""} ${a?.email || ""}`,
                }))}
              />
            </Form.Item>
          </div>

          {/* Select Account Type */}
          <div className="mt-4">
            <label className="text-base font-medium block">
              Select Account Type
            </label>

            <Select
              className="ant-select-selector-white w-full"
              placeholder="Select account type"
              options={accountTypes}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              value={selectedAccountTypeSync}
              onChange={(value) => setSelectedAccountTypeSync(value)}
            />
          </div>

          {/* Submit */}
          <div className="mt-4">
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold px-8 py-1.5 rounded-lg"
              lable={"submit"}
              isLoading={finalLoading}
              onClick={handleFinalSubmit}
              loadingLable={"submitting"}
              disabled={
                !fromAccount || !mt5AcDetails || !selectedAccountTypeSync
              }
            />
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
}
